<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      id="group20211203"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menu" slot-scope="scope">
        <el-button
          icon="el-icon-view"
          size="mini"
          type="text"
          v-if="permission.group_edit"
          @click="handleViewRow(scope.row)"
          >查看</el-button
        >
        <el-button
          icon="el-icon-edit"
          size="mini"
          type="text"
          v-if="permission.group_view"
          @click="handleEditRow(scope.row)"
          >编辑</el-button
        >

        <el-button
          icon="el-icon-delete"
          size="mini"
          type="text"
          v-if="permission.group_delete"
          @click="rowDel(scope.row)"
          >删除</el-button
        >
      </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.group_add"
          @click="handleAddGroupForm"
          >新 增
        </el-button>
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.group_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
    <!-- <el-dialog
            title="新增班组"
            :visible.sync="dialogGroupFormVisible"
            append-to-body
            :before-close="handleAddGroupFormClose">
            <el-form :model="addGroupForm" ref="addGroupForm" label-width="100px" v-if="dialogGroupFormVisible">
              <el-form-item label="项目名称"    :rules="[{ required: true, message: '项目名称不能为空！', trigger: 'blur' }]">
                <el-col :span="11" >
                  <el-select
                             style="width:100%"
                             v-model="addGroupForm.projectId"
                             @change="changeHandler_">
                    <el-option
                      v-for="(item,index) in projectList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >

                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="服务类型"  prop="moduleType"  :rules="[{ required: true, message: '服务类型不能为空！', trigger: 'blur' }]">
                <el-col :span="11" >
                  <el-select style="width:100%"
                             v-model="addGroupForm.moduleType">
                    <el-option
                      v-for="(item,index) in moduleTypeList"
                      :key="index"
                      :label="item.dictValue"
                      :value="item.dictKey"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>

                <el-form-item label="班组名称" prop="name" :rules="[{ required: true, message: '班组名称不能为空！', trigger: 'blur' }]">
                    <el-col :span="11">
                        <el-input maxlength="30"
                                  show-word-limit
                                  v-model="addGroupForm.name"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="班组成员"  :rules="[{ required: true, message: '请选择班组成员！', trigger: 'blur' }]">

                    <el-col :span="19">
                        <el-input readonly
                                  v-model="menberNames"></el-input>
                        <el-input readonly
                                  v-model="addGroupForm.menberIds"
                                  style="display:none;"></el-input>
                    </el-col>
                    <el-col :span="5">
                        <el-button @click="handleAddGroup(1,1)" type="primary">请选择</el-button>
                    </el-col>
                </el-form-item>
                <el-form-item label="班组负责人" :rules="[{ required: true, message: '请选择班组负责人！', trigger: 'blur' }]">
                    <el-col :span="19">
                        <el-input readonly v-model="principalNames"></el-input>
                        <el-input readonly v-model="addGroupForm.principalIds" style="display:none;"></el-input>
                    </el-col>
                    <el-col :span="5">
                        <el-button @click="handleAddGroup(2,1)" type="primary">请选择</el-button>
                    </el-col>
                </el-form-item>
                <el-form-item style="margin-left: 30%;">
                    <el-button type="primary" @click="handleSubmitAddGroupForm">保存</el-button>
                    <el-button @click="handleAddGroupFormClose">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog> -->

    <hr-dialog
      title="新增班组"
      ref="remarkTemp"
      :visible.sync="dialogGroupFormVisible"
      width="50%"
      :handleClose="handleAddGroupFormClose"
    >
      <template v-slot:body>
        <el-form
          :model="addGroupForm"
          ref="addGroupForm"
          label-width="100px"
          v-if="dialogGroupFormVisible"
        >
          <el-form-item
            label="项目名称"
            :rules="[{ required: true, message: '项目名称不能为空！', trigger: 'blur' }]"
          >
            <el-col :span="11">
              <el-select
                style="width: 100%"
                v-model="addGroupForm.projectId"
                @change="changeHandler_"
              >
                <el-option
                  v-for="(item, index) in projectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <!-- <el-form-item
            label="服务类型"
            prop="moduleType"
            :rules="[{ required: true, message: '服务类型不能为空！', trigger: 'blur' }]"
          >
            <el-col :span="11">
              <el-select style="width: 100%" v-model="addGroupForm.moduleType" placeholder="请选择 服务类型">
                <el-option
                  v-for="(item, index) in moduleTypeList"
                  :key="index"
                  :label="item.dictValue"
                  :value="String(item.dictKey)"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-form-item> -->

          <el-form-item
            label="班组名称"
            prop="name"
            :rules="[{ required: true, message: '班组名称不能为空！', trigger: 'blur' }]"
          >
            <el-col :span="11">
              <el-input maxlength="30" show-word-limit v-model="addGroupForm.name" placeholder="请输入 班组名称"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item
            label="班组成员"
            :rules="[{ required: true, message: '请选择班组成员！', trigger: 'blur' }]"
          >
            <el-col :span="19">
              <el-input readonly v-model="menberNames" placeholder="请选择 班组成员"></el-input>
              <el-input readonly v-model="addGroupForm.menberIds" style="display: none"></el-input>
            </el-col>
            <el-col :span="5">
              <el-button @click="handleAddGroup(1, 1)" type="primary">请选择</el-button>
            </el-col>
          </el-form-item>
          <el-form-item
            label="班组负责人"
            :rules="[{ required: true, message: '请选择班组负责人！', trigger: 'blur' }]"
          >
            <el-col :span="19">
              <el-input readonly v-model="principalNames" placeholder="请选择 班组负责人"></el-input>
              <el-input
                readonly
                v-model="addGroupForm.principalIds"
                style="display: none"
              ></el-input>
            </el-col>
            <el-col :span="5">
              <el-button @click="handleAddGroup(2, 1)" type="primary">请选择</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </template>
      <template slot="footer">
        <el-button
          type="primary"
          @click="handleSubmitAddGroupForm"
          style="padding: 9px 15px; font-size: 12px; border-radius: 3px"
        >
          <i class="el-icon-circle-plus-outline"></i> <span>保 存</span>
        </el-button>
        <el-button
          @click="handleAddGroupFormClose"
          style="padding: 9px 15px; font-size: 12px; border-radius: 3px; margin-right: 20px"
        >
          <i class="el-icon-circle-close"></i> <span>取 消</span>
        </el-button>
      </template>
    </hr-dialog>
    
    <hr-dialog
      :close-on-click-modal = 'flagIsFalse'
      title="编辑班组"
      :visible.sync="dialogEditGroupFormVisible"
      append-to-body
      :before-close="handleEditGroupFormClose"
      ref="group20211206"
    >
      <template v-slot:body>
      <el-form label-width="100px" :model="editGroupForm" ref="editGroupForm">
        <el-form-item
          label="项目名称"
          :rules="[{ required: true, message: '项目名称不能为空！', trigger: 'blur' }]"
        >
          <el-col :span="11">
            <el-select
              disabled
              style="width: 100%"
              v-model="editGroupForm.projectId"
              @change="changeHandler"
            >
              <el-option
                v-for="(item, index) in projectList"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <!-- <el-form-item
          label="服务类型"
          prop="moduleType"
          :rules="[{ required: true, message: '服务类型不能为空！', trigger: 'blur' }]"
        >
          <el-col :span="11">
            <el-select disabled style="width: 100%" v-model="editGroupForm.moduleType">
              <el-option
                v-for="(item, index) in moduleTypeList"
                :key="index"
                :label="item.dictValue"
                :value="String(item.dictKey)"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item> -->
        <el-form-item
          label="班组名称"
          prop="name"
          :rules="[{ required: true, message: '班组名称不能为空！', trigger: 'blur' }]"
        >
          <el-col :span="11">
            <el-input maxlength="30" show-word-limit v-model="editGroupForm.name"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item
          label="班组成员"
          :rules="[{ required: true, message: '请选择班组成员！', trigger: 'blur' }]"
        >
          <el-col :span="19">
            <el-input readonly v-model="menberNames"></el-input>
            <el-input readonly v-model="editGroupForm.menberIds" style="display: none"></el-input>
          </el-col>
          <el-col :span="5">
            <el-button @click="handleEditGroup(1, 2)" type="primary">请选择</el-button>
          </el-col>
        </el-form-item>
        <el-form-item
          label="班组负责人"
          :rules="[{ required: true, message: '请选择班组负责人！', trigger: 'blur' }]"
        >
          <el-col :span="19">
            <el-input readonly v-model="principalNames"></el-input>
            <el-input
              readonly
              v-model="editGroupForm.principalIds"
              style="display: none"
            ></el-input>
          </el-col>
          <el-col :span="5">
            <el-button @click="handleEditGroup(2, 2)" type="primary">请选择</el-button>
          </el-col>
        </el-form-item>
        <!--              <el-form-item label="描述">-->
        <!--                <el-col :span="20">-->
        <!--                  <el-input type="textarea" :rows="2" maxlength="300" show-word-limit v-model="editGroupForm.description"></el-input>-->
        <!--                </el-col>-->
        <!--              </el-form-item>-->
       
      </el-form>
        </template>
        <template slot="footer">
           <div>
          <el-button type="primary" @click="handleSubmitEditGroupForm" style="padding: 9px 15px; font-size: 12px; border-radius: 3px">
            <i class="el-icon-circle-plus-outline"></i> <span>修 改</span>
          </el-button>
          <el-button @click="handleEditGroupFormClose" style="padding: 9px 15px; font-size: 12px; border-radius: 3px;margin-right:25px">
            <i class="el-icon-circle-close"></i> <span>取 消</span>
          </el-button>
        </div>
        </template>
    </hr-dialog>

    <hr-dialog
      :close-on-click-modal = 'flagIsFalse'
      title="查看"
      :visible.sync="dialogViewGroupFormVisible"
      append-to-body
      :before-close="handleClose"
    >
      <template v-slot:body>
      <el-form label-width="100px">
        <el-form-item label="项目名称">
          <el-col :span="11">
            <el-select
              style="width: 100%"
              disabled
              v-model="viewGroupForm.projectId"
              @change="changeHandler"
            >
              <el-option
                v-for="(item, index) in projectList"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="服务类型">
          <el-col :span="11">
            <el-select style="width: 100%" disabled v-model="viewGroupForm.moduleType">
              <el-option
                v-for="(item, index) in moduleTypeList"
                :key="index"
                :label="item.dictValue"
                :value="String(item.dictKey)"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item> -->
        <el-form-item label="班组名称">
          <el-col :span="11">
            <el-input disabled v-model="viewGroupForm.name"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="班组成员">
          <el-col :span="19">
            <el-input disabled v-model="menberNames"></el-input>
            <el-input disabled v-model="viewGroupForm.menberIds" style="display: none"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="班组负责人">
          <el-col :span="19">
            <el-input disabled v-model="principalNames"></el-input>
            <el-input
              disabled
              v-model="viewGroupForm.principalIds"
              style="display: none"
            ></el-input>
          </el-col>
          <!-- <el-col :span="5">
                        <el-button @click="handleAddGroup(2,2)" type="primary">请选择</el-button>
                    </el-col> -->
        </el-form-item>
        <!--              <el-form-item label="描述">-->
        <!--                <el-col :span="20">-->
        <!--                  <el-input type="textarea" :rows="2" readonly v-model="viewGroupForm.description"></el-input>-->
        <!--                </el-col>-->
        <!--              </el-form-item>-->
      </el-form>
      </template>
    </hr-dialog>

    <el-dialog
      title="请选择人员"
      :visible.sync="dialogUserEditBoxVisible"
      fullscreen
      append-to-body
      width="80%"
    >
      <user-edit-box
        v-if="dialogUserEditBoxVisible"
        :remainUserListInside.sync="remainUserList"
        @closeAction="handleCloseAction"
        @submitAction="handleSubmitAction"
        @editAction="handleEditAction"
        :selectType.sync="selectUserType"
        :handleAction.sync="handleAction"
        :projectId.sync="tempProjectId"
      />
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  saveAddFormData,
  saveEditFormData,
  getMenberUserList,
  getPrincipalUserList,
  remove,
  update,
  getProjectList,
} from '@/api/crmedical/group/group';
import { mapGetters } from 'vuex';
import userEditBox from './user-edit-box';
import { getDictionary } from '@/api/system/dict';

export default {
  watch:{
    '$route.path':function(newVal,oldVal){
          // console.log(newVal + '---' +  oldVal);
          if(newVal === '/crmedical/group/group'){
             this.$refs.crud.$refs.table.doLayout()
          }
        }
  },
  components: {
    userEditBox,
  },
  data: function () {
    return {
      flagIsFalse:false,
      serachFlag:true,
      todoListLength: 10000000000000000,
      dataSelectedPrincipalUsers: [],
      dataSelectedMenberUsers: [],
      remainPrincipalUserList: [],
      remainMenberUserList: [],
      remainUserList: [],
      firstDisplayFlag: false,
      reWrite: false,
      tempProjectId: '',
      principalNames: '',
      menberNames: '',
      selectUserType: '',
      handleAction: '',
      projectList: [],
      moduleTypeList: [],
      addGroupForm: {},
      editGroupForm: {},
      viewGroupForm: {},
      dialogGroupFormVisible: false,
      dialogEditGroupFormVisible: false,
      dialogUserEditBoxVisible: false,
      dialogViewGroupFormVisible: false,
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        // dialogWidth:'65%',
        dialogClickModal: false,
        height: 'auto',
        calcHeight: 50,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        selection: true,
        addBtn: false,
        editBtn: false,
        viewBtn: false,
        delBtn: false,
        columnBtn: true,
        refreshBtn: true,
        searchMenuSpan: 6,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '项目名称',
            prop: 'projectId',
            type: 'tree',
            searchClearable: false,
            search: true,
            // dicUrl: '/api/v4ward/project/getProjectList',
            props: { label: 'name', value: 'id' },
          },
          {
            label: '班组名称',
            prop: 'name',
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            search: true,
          },
          // {
          //   label: '服务类型',
          //   prop: 'moduleType',
          //   type: 'select',
          //   search: false,
          //   dataType: 'string',
          //   dicUrl: "/api/blade-system/dict/dictionary?code=module_type",
          //   props: {
          //     label: 'dictValue',
          //     value: 'dictKey',
          //   },
          // },
          {
            label: '班组负责人',
            prop: 'principalNames',
            overHidden: true,
          },
          {
            label: '班组成员',
            prop: 'crewNames',
            overHidden: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.group_add, false),
        viewBtn: this.vaildData(this.permission.group_view, false),
        delBtn: this.vaildData(this.permission.group_delete, false),
        editBtn: this.vaildData(this.permission.group_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    //初始高度
    this.option.height = this.bodyHeight - 398 + 55;

    //加载列表

    getDictionary({ code: 'module_type' }).then((res) => {
      this.moduleTypeList = res.data.data;
      console.log(res.data.data);
      this.moduleTypeList.map((item) => {
        item.dictKey = Number(item.dictKey);
      });
     
     
      getProjectList({}).then((res) => {
        this.projectList = res.data;
        if (this.projectList.length > 0) {
          this.query.projectId = this.projectList[0].id;
          this.tempProjectId = this.projectList[0].id;
        }
        this.$nextTick(() => {
          this.reWrite = true;
          const column1 = this.findObject(this.option.column, 'projectId');
          column1.dicData = this.projectList;
          setTimeout(() => {
            this.$refs.crud.$children[1].$children[4].$el.addEventListener('click', () => {
              console.log('this.todoListLength click click click', this.todoListLength);
              console.log(this.option.height, this.bodyHeight);
              this.serachFlag = !this.serachFlag
              this.clickChangeHeight()
            });
          });
        });
        //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
        this.firstDisplayFlag = true;
      });
    });
  },
  mounted() {
    
  },
  methods: {
    clickChangeHeight(){
      if (this.todoListLength === 0) {
                if (this.option.height == this.bodyHeight - 398 + 55 + (78 - 46)) {
                  this.option.height = this.bodyHeight - 287 + 1 + (78 - 46);
                } else {
                  this.option.height = this.bodyHeight - 398 + 55 + (78 - 46);
                }
              } else {
                if (this.option.height == this.bodyHeight - 398 + 55) {
                  this.option.height = this.bodyHeight - 287 + 1;
                } else {
                  this.option.height = this.bodyHeight - 398 + 55;
                }
              }
              this.$refs.crud.getTableHeight();
    },
    getProjectNameById(projectId) {
      let projectName = '';
      this.projectList.forEach(function (value, index, array) {
        if (value.id === projectId) {
          projectName = value.name;
          return;
        }
      });
      return projectName;
    },
    handleClose() {
      this.principalNames = '';
      this.menberNames = '';
      this.viewGroupForm = {};
      this.dialogViewGroupFormVisible = false;
    },
    handleViewRow(row) {
     
      this.viewGroupForm = row;
      getProjectList().then((res) => {
        console.log(res);
        this.projectList = res.data;
        // this.addGroupForm.projectId = this.projectList[0].id;
      });
      getPrincipalUserList({ groupId: row.id }).then((res) => {
        console.log(res);
        let idList = [];
        let idListString = '';
        let nameList = [];
        let nameListString = '';
        res.data.forEach((ele, i) => {
          idList.push(ele.id);
          nameList.push(ele.realNameAndPhone);
        });
        if (idList.length > 0) {
          idListString = idList.join(',');
          nameListString = nameList.join(',');
        }
        this.viewGroupForm.principalIds = idListString;
        this.principalNames = nameListString;
        console.log(this.principalNames);
      });
      getMenberUserList({ groupId: row.id }).then((res) => {
        console.log(res);
        let idList = [];
        let idListString = '';
        let nameList = [];
        let nameListString = '';
        res.data.forEach((ele, i) => {
          idList.push(ele.id);
          nameList.push(ele.realNameAndPhone);
        });
        if (idList.length > 0) {
          idListString = idList.join(',');
          nameListString = nameList.join(',');
        }
        this.viewGroupForm.menberIds = idListString;
        this.menberNames = nameListString;
        console.log(this.menberNames);
      });
      console.log(row);
      console.log(this.viewGroupForm);
      this.dialogViewGroupFormVisible = true;
    },
    handleEditRow(row) {
      // row.moduleType = row.moduleType.toString();
      this.editGroupForm = this.deepClone(row);
      getProjectList().then((res) => {
        this.projectList = res.data;
      });
      getPrincipalUserList({ groupId: row.id }).then((res) => {
        this.remainPrincipalUserList = res.data;
        let idList = [];
        let idListString = '';
        let nameList = [];
        let nameListString = '';
        res.data.forEach((ele, i) => {
          idList.push(ele.id);
          nameList.push(ele.realNameAndPhone);
        });
        if (idList.length > 0) {
          idListString = idList.join(',');
          nameListString = nameList.join(',');
        }
        this.editGroupForm.principalIds = idListString;
        this.principalNames = nameListString;
        console.log(this.principalNames);
      });
      getMenberUserList({ groupId: row.id }).then((res) => {
        this.remainMenberUserList = res.data;
        console.log(res);
        let idList = [];
        let idListString = '';
        let nameList = [];
        let nameListString = '';
        res.data.forEach((ele, i) => {
          idList.push(ele.id);
          nameList.push(ele.realNameAndPhone);
        });
        if (idList.length > 0) {
          idListString = idList.join(',');
          nameListString = nameList.join(',');
        }
        this.editGroupForm.menberIds = idListString;
        this.menberNames = nameListString;
        console.log(this.menberNames);
      });
      console.log(row);
      console.log(this.editGroupForm);
      this.dialogEditGroupFormVisible = true;
    },
    handleCloseAction() {
      this.dialogUserEditBoxVisible = false;
    },
    handleSubmitAddGroupForm() {
      this.$refs.addGroupForm.validate((valid) => {
        if (valid) {
          saveAddFormData(this.addGroupForm).then((res) => {
            console.log(res);
            this.onLoad();
            this.handleAddGroupFormClose();
            this.dialogGroupFormVisible = false;
          });
        } else {
          return;
        }
      });
    },
    handleSubmitEditGroupForm() {
      this.$refs.editGroupForm.validate((valid) => {
        if (valid) {
          saveEditFormData(this.editGroupForm).then((res) => {
            console.log(res);
            this.onLoad();
            this.handleEditGroupFormClose();
            this.dialogEditGroupFormVisible = false;
          });
        } else {
          return;
        }
      });
    },
    handleAddGroupFormClose() {
      this.principalNames = '';
      this.menberNames = '';
      this.addGroupForm = {};
      this.dialogGroupFormVisible = false;
    },
    handleEditGroupFormClose() {
      this.principalNames = '';
      this.menberNames = '';
      this.editGroupForm = {};
      this.dialogEditGroupFormVisible = false;
    },
    changeHandler(val) {
      console.log(val);
      // this.$set(this.addGroupForm,'projectId',val);
      this.addGroupForm = Object.assign({}, this.addGroupForm, { projectId: val });
      console.log(this.addGroupForm.projectId);
    },
    changeHandler_(val) {
      console.log(val);
      // this.$set(this.addGroupForm,'projectId',val);
      this.editGroupForm = Object.assign({}, this.editGroupForm, { projectId: val });
      console.log(this.editGroupForm.projectId);
    },

    handleSubmitAction(val) {
      console.log('handleSubmitAction=====>', val);
      if (val.selectType == 1) {
        this.addGroupForm.menberIds = val.idListString;
        this.menberNames = val.nameListString;
        this.dataSelectedMenberUsers = val.dataSelectedUsers;
      } else {
        this.addGroupForm.principalIds = val.idListString;
        this.principalNames = val.nameListString;
        this.dataSelectedPrincipalUsers = val.dataSelectedUsers;
      }
      this.dialogUserEditBoxVisible = false;
    },
    handleEditAction(val) {
      console.log('handleEditAction=====>', val);
      if (val.selectType == 1) {
        this.editGroupForm.menberIds = val.idListString;
        this.menberNames = val.nameListString;
        this.remainMenberUserList = val.dataSelectedUsers;
      } else {
        this.editGroupForm.principalIds = val.idListString;
        this.principalNames = val.nameListString;
        this.remainPrincipalUserList = val.dataSelectedUsers;
      }
      this.dialogUserEditBoxVisible = false;
    },
    handleAddGroupForm() {
      getProjectList().then((res) => {
        console.log(res);
        this.projectList = res.data;
        this.addGroupForm.projectId = this.query.projectId;
      });
      this.dataSelectedMenberUsers = [];
      this.dataSelectedPrincipalUsers = [];
      this.dialogGroupFormVisible = true;
    },
    handleEditGroupForm() {
      getProjectList().then((res) => {
        console.log(res);
        this.projectList = res.data;
        this.addGroupForm.projectId = this.projectList[0].id;
      });
      // this.dataSelectedMenberUsers = [];
      // this.dataSelectedPrincipalUsers = [];
      this.dialogGroupFormVisible = true;
    },
    // handleAddGroup(type,status){
    handleAddGroup(type) {
      // if(status==1){
      this.tempProjectId = this.addGroupForm.projectId;
      this.handleAction = 1;
      // }else{
      //     this.tempProjectId = this.editGroupForm.projectId
      //     this.handleAction = 2;
      // }
      if (type == 1) {
        this.remainUserList = this.dataSelectedMenberUsers;
        this.selectUserType = 1;
      } else {
        this.remainUserList = this.dataSelectedPrincipalUsers;
        this.selectUserType = 2;
      }
      console.log(this.remainUserList);
      console.log(this.remainMenberUserList);
      console.log(this.remainPrincipalUserList);
      this.dialogUserEditBoxVisible = true;
    },

    // handleEditGroup(type,status){
    handleEditGroup(type) {
      // if(status==1){
      //     this.tempProjectId = this.addGroupForm.projectId
      //     this.handleAction = 1;
      // }else{
      this.tempProjectId = this.editGroupForm.projectId;
      this.handleAction = 2;
      // }
      if (type == 1) {
        // if(this.dataSelectedMenberUsers.length>0){
        this.remainUserList = this.remainMenberUserList;
        // }else{
        // this.remainUserList = this.remainMenberUserList;
        // }
        this.selectUserType = 1;
      } else {
        // if(this.dataSelectedPrincipalUsers.length>0){
        this.remainUserList = this.remainPrincipalUserList;
        // }else{
        // this.remainUserList = this.remainPrincipalUserList;
        // }
        this.selectUserType = 2;
      }
      console.log(this.remainUserList);
      console.log(this.remainMenberUserList);
      console.log(this.remainPrincipalUserList);
      this.dialogUserEditBoxVisible = true;
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query.name = '';
      this.query.moduleType = '';
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
      if (!this.query.projectId) {
        this.query.projectId = this.tempProjectId;
      }
      if (this.query.projectId) {
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.todoListLength = data.records.length;
            if(this.serachFlag){
                if (data.records.length === 0) {
                  this.option.height = this.bodyHeight - 398 + (78 - 46) + 55;
                } else {
                  this.option.height = this.bodyHeight - 398 + 55;
                }
                this.$refs.crud.getTableHeight();
            }
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
            if (this.firstDisplayFlag) {
              let ent = document.querySelector('input[placeholder="项目名称"]');
              ent.value = this.getProjectNameById(this.query.projectId);
              this.tempProjectId = this.query.projectId;
              //关闭默然显示，重刷页面时才开启默认显示
              this.firstDisplayFlag = false;
            }
          }
        );
      } else {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
#group20211203 .avue-form__menu--center {
  padding-left: 125px !important;
}
</style>
<style lang='scss' scoped>
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 1px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>
